import {
    temAcesso
} from '@/shared/auth/temAcesso'

const Dirfs = () => import('./Dirfs.vue')
const DirfDetalhar = () => import('./DirfDetalhar.vue')

export default {
    path: 'dirfs',
    name: 'Dirfs',
    component: Dirfs,
    beforeEnter: (to, from, next) => {
        if (temAcesso('DIRFS-00')) {
            next()
        }
    },
    children: [{
        path: ':dirfId',
        name: 'Dirfs_Detalhar',
        component: DirfDetalhar,
        beforeEnter: (to, from, next) => {
            if (temAcesso('DIRFS-02')) {
                next()
            }
        },
        children: [{
            path: 'beneficiario/:dirfBeneficiarioId',
            name: 'Dirfs_Detalhar_Beneficiario',
            component: DirfDetalhar,
            beforeEnter: (to, from, next) => {
                if (temAcesso('DIRFS-02')) {
                    next()
                }
            }
        }]
    }]
}
